/* global axios */
import ApiClient from './ApiClient';

class PlatformAnnouncementsAPI extends ApiClient {
  constructor() {
    super('platform_announcements', { accountScoped: true });
  }

  read(id) {
    return axios.patch(`${this.url}/${id}/read`);
  }

  dismiss(id) {
    return axios.patch(`${this.url}/${id}/dismiss`);
  }

  readAll() {
    return axios.patch(`${this.url}/read_all`);
  }
}

export default new PlatformAnnouncementsAPI();
